<template>
    <div
        class="base-scroll"
        :class="{
            'base-scroll__no-bars' : noBars,
            'base-scroll__has-border' : hasBorder
        }"
        :style="`height: ${height};`"
    >
        <div class="base-scroll__content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            noBars: {
                type: Boolean,
                default: false
            },

            hasBorder: {
                type: Boolean,
                default: false
            },

            height: {
                type: String,
                required: true
            }
        }
    }
</script>

<style src="./BaseScroll.scss" lang="scss" scoped></style>
